const TaxTableSports = ({ fees }) => {
    if (!fees) return null;

    return (
        <>
            <table className="table table-bordered table-hover margin-b30">
                <thead className="light-grey-background">
                    <tr>
                        <th>Description</th>
                        <th className="text-right">Amount (₹)</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>{fees.isPerPerson ? 'Sports Fee' : 'Session Cost'}</td>
                        <td className="text-right">₹ {fees.rate.toFixed(2)}</td>
                    </tr>
                    {fees.discount > 0 && (
                        <tr>
                            <td>Discount</td>
                            <td className="text-right">- ₹ {fees.discount.toFixed(2)}</td>
                        </tr>
                    )}
                    <tr>
                        <td>SGST (9%)</td>
                        <td className="text-right">₹ {(fees.tax / 2).toFixed(2)}</td>
                    </tr>
                    <tr>
                        <td>CGST (9%)</td>
                        <td className="text-right">₹ {(fees.tax / 2).toFixed(2)}</td>
                    </tr>
                    <tr>
                        <td><strong>Total</strong></td>
                        <td className="text-right"><strong>₹ {fees.total.toFixed(2)}</strong></td>
                    </tr>
                </tbody>
            </table>
        </>
    );
};

export default TaxTableSports;
